import React, { useState, useCallback, createContext } from 'react';
import PropTypes from 'prop-types';
import { Toast } from '@components/v1/Toast';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((options) => {
    setToast({ ...options, onClose: () => setToast(null) });
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast && <Toast {...toast} />}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired
};
